export interface AssetFields {
    title?: string;
    description: string;
    file: {
        url: string;
        details: {
            size: number;
            image?: {
                width: number;
                height: number;
            }
        }
        fileName: string;
        contentType: string;
    };
}

export interface HyperlinkFields {
    data: {
        uri: string;
    };
    content: Array<{value: string}>;
}

export interface FlatAssetFields {
    title?: string;
    description?: string;
    url: string;
    size: number;
    fileName: string;
    contentType: string;
}

export interface FlatImageFields extends FlatAssetFields {
    width: number;
    height: number;
}

export interface FlatHyperlinkFields {
    uri: string;
    title: string;
}

export function flattenAssetFields(fields: AssetFields): FlatAssetFields {
    const flatAsset = {
        title: fields.title,
        description: fields.description,
        url: fields.file.url,
        size: fields.file.details.size,
        fileName: fields.file.fileName,
        contentType: fields.file.contentType
    };
    const image = fields.file.details.image;
    if (image) {
        return Object.assign({}, flatAsset, { ...image });
    } else {
        return flatAsset;
    }
}

export function flattenHyperlinkFields(fields: HyperlinkFields): FlatHyperlinkFields {
    return {
        uri: fields.data.uri,
        title: fields.content.pop()!.value,
    };
}



// WEBPACK FOOTER //
// ./src/contentful/assetTools.ts